import type { Category } from '~~/types/commercetools';

import { removeEmptyCategories } from '~~/helpers/category/categoriesTree';
import { sortCategories } from '~~/helpers/category/sortCategories';
import { getBreadcrumbsFromProduct } from '~~/helpers/category/getBreadcrumbsFromProduct';
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export default function () {

  const { languageAndCountry } = useLocalization();

  const getProductFirstLevelCategoryChildren = (
    categories: Category[],
    product: ProductVariantExtended,
  ): Category[] => {

    const productFirstLevelCategoryChildren = computed(() => {

      if (!product || !product._breadcrumbs) {

        return [];
      
      }

      const breadcrumbs = getBreadcrumbsFromProduct(product);
      const secondBreadcrumbSlug = breadcrumbs?.at(1)?.slug;

      if (!secondBreadcrumbSlug) {

        return [];
      
      }

      const productFirstLevelCategory = categories.find(category => category.slug === secondBreadcrumbSlug);

      if (!productFirstLevelCategory) {

        return [];
      
      }

      const secondLevelCategories = productFirstLevelCategory.children || [];

      if (!secondLevelCategories.length) {

        return [];
      
      }

      const filteredChildren = secondLevelCategories.filter(child =>
        removeEmptyCategories([child], languageAndCountry.value).length > 0,
      );

      const sortedChildren = filteredChildren.map(product => ({
        ...product,
        link: `/${product.slug}`,
        hideChevron: true,
      }));

      sortCategories(sortedChildren);

      return sortedChildren;
    
    });

    return productFirstLevelCategoryChildren.value;
  
  };

  return {
    getProductFirstLevelCategoryChildren,
  };

}
